import { useDispatch, useSelector } from "react-redux";
import { fetchClinics } from "utilities/redux/slices/clinicsSlice";
import { List, Button, Typography, Card, Statistic, Flex } from "antd";
import { React, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RightOutlined } from "@ant-design/icons";

const ClinicList = ({ region }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const clinics = useSelector((state) => state.clinics.data);

  useEffect(() => {
    const filters = {
      region: region,
      status: ["Open", "To Open", "Closed (Temp)"],
    };
    dispatch(fetchClinics(filters));
  }, [region]);

  return (
    <Card
      title={
        <Flex justify="space-between" style={{ padding: "16px" }}>
          <Typography.Title level={4}>Clinics</Typography.Title>
          <Statistic title="Total" value={clinics.length} />
        </Flex>
      }
      bordered
      style={{ height: "100%", display: "flex", flexDirection: "column" }}
      bodyStyle={{ height: "100%", flexGrow: 1, overflowY: "scroll" }}
    >
      <List
        dataSource={clinics}
        renderItem={(clinic) => (
          <List.Item
            actions={[
              <Button
                type="text"
                icon={<RightOutlined />}
                onClick={() => navigate(`/clinics/${clinic.clinic}`)}
              />,
            ]}
          >
            <List.Item.Meta
              title={
                <Typography.Text strong>
                  {clinic.clinic} - {clinic.clinicName}
                </Typography.Text>
              }
              description={
                <Typography.Text type="secondary">
                  Status: {clinic.status}
                </Typography.Text>
              }
            />
          </List.Item>
        )}
      />
    </Card>
  );
};

export default ClinicList;
